<script setup lang="ts">
import BrandMark from './BrandMark.vue'
</script>

<template>
  <header
    class="flex h-[50px] shrink-0 items-center bg-bar px-5 text-on-bar shadow-header"
    data-testid="brand-bar"
  >
    <BrandMark />
  </header>
</template>
